import { CHAIR_CAMERA_DIMS } from './constants.js';

/**
 * VapiCamera - Component where the user's camera is shown.
 * Same dimensions as VapiChair (160×140). Shows only the webcam video.
 * Implements updatePoster(mesh) to sync with drag like VRIframeAgentGhost.
 */
class VapiCamera {

    constructor(options = {}) {
        const [w, h] = CHAIR_CAMERA_DIMS;
        this.width = options.width ?? w;
        this.height = options.height ?? h;
        this.userName = options.userName ?? '';
        window.vapicamera = this;
    }

    render() {
        const div = document.createElement('div');
        div.setAttribute('class', 'vrai-component-slot');
        div.setAttribute('data-vrai-component', 'camera');
        div.style.pointerEvents = 'none';
        const userName = this.userName || '';
        div.innerHTML = `
            <div class="vrai-component-content" style="position:absolute;inset:0;overflow:hidden;pointer-events:auto;">
                <div class="vrai-agent-camera-wrapper-transfrom">
                    <main class="vrai-agent-view vrai-agent-call" data-view="call">
                        <div class="vrai-agent-cameras">
                            <div class="vrai-agent-camera-wrapper">
                                <video class="vrai-webcam" autoplay playsinline muted></video>
                                <img class="vrai-webcam-avatar-fallback" alt="" onerror="this.onerror=null;this.src='./textures/defaultAvatar.png'" style="display:none;position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:14px;pointer-events:none;z-index:1;" />
                                <button type="button" class="vrai-agent-chair-end-indicator vrai-agent-camera-end-call" aria-label="${(typeof $trans !== 'undefined' && $trans('action-end-call')) || 'End call'}" tabindex="-1"><span class="material-icons-outlined" aria-hidden="true">call_end</span></button>
                                <div class="vrai-agent-camera-footer">
                                    <div class="vrai-agent-camera-name">${userName}</div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        `;
        this._root = div;
        return div;
    }

    getContentElement() {
        return this._root?.querySelector('.vrai-component-content');
    }

    /** Sync poster position/rotation with dragged mesh (like VRIframeAgentGhost.updatePoster). */
    updatePoster(posterObj, mesh) {
        if (!posterObj || !mesh) return;
        posterObj.position.copy(mesh.position);
        posterObj.quaternion.copy(mesh.quaternion);
        posterObj.rotation.copy(mesh.rotation);
        posterObj.scale.copy(mesh.scale);
    }
}

export { VapiCamera };
